import PropTypes from 'prop-types';
import { useSelector } from 'react-redux';

/**
 * Allow actions according to receivable type
 * @param {node} children The element to be rendered
 * @param {array} subject Contains all receivable type
 */
const ReceivableAbility = ({ children, subject, allowed }) => {
  const receivableType = useSelector(
    (state) => state.config?.settings?.core?.receivable?.type
  );

  const isAllowed = () => {
    if (subject?.includes(receivableType) || allowed) {
      return true;
    }
  };

  return isAllowed() ? children : null;
};

ReceivableAbility.propTypes = {
  allowed: PropTypes.bool,
  subject: PropTypes.array.isRequired,
  children: PropTypes.node.isRequired,
};

ReceivableAbility.defaultProps = {
  allowed: false,
  subject: [],
};

export default ReceivableAbility;
